import { supabase } from '../config/supabase';
import { TABLES } from '../data/tables';
import { ServiceLocation } from '../data/types/domain';

export const serviceLocationService = {
  async getServiceLocations(): Promise<ServiceLocation[]> {
    const { data, error } = await supabase
      .from(TABLES.SERVICE_LOCATION)
      .select('*');
    
    if (error) throw error;
    return data || [];
  },

  async getServiceLocationById(id: number): Promise<ServiceLocation | null> {
    const { data, error } = await supabase
      .from(TABLES.SERVICE_LOCATION)
      .select('*')
      .eq('id', id)
      .single();
    
    if (error) throw error;
    return data || null;
  },

  async getServiceLocationsByBusiness(businessId: number): Promise<ServiceLocation[]> {
    const { data, error } = await supabase
      .from(TABLES.SERVICE_LOCATION)
      .select('*')
      .eq('business_id', businessId);
    
    if (error) throw error;
    return data || [];
  },

  async createServiceLocation(location: Omit<ServiceLocation, 'id' | 'created_at' | 'updated_at'>): Promise<ServiceLocation> {
    const { data, error } = await supabase
      .from(TABLES.SERVICE_LOCATION)
      .insert([{
        ...location,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      }])
      .select()
      .single();
    
    if (error) throw error;
    return data;
  },

  async updateServiceLocation(
    id: number,
    updates: Partial<Omit<ServiceLocation, 'id' | 'created_at' | 'updated_at'>>
  ): Promise<ServiceLocation> {
    const { data, error } = await supabase
      .from(TABLES.SERVICE_LOCATION)
      .update({
        ...updates,
        updated_at: new Date().toISOString(),
      })
      .eq('id', id)
      .select()
      .single();
    
    if (error) throw error;
    return data;
  },

  async updateServiceLocations(
    businessId: number,
    locations: Partial<Omit<ServiceLocation, 'id' | 'created_at' | 'updated_at'>>[]
  ): Promise<ServiceLocation[]> { 
    const { data, error } = await supabase
      .from(TABLES.SERVICE_LOCATION)
      .update(locations.map(location => ({
        ...location,
        updated_at: new Date().toISOString(),
      })))
      .eq('business_id', businessId)
      .select();
    
    if (error) throw error;
    return data;
  },

  async deleteServiceLocation(id: number): Promise<void> {
    const { error } = await supabase
      .from(TABLES.SERVICE_LOCATION)
      .delete()
      .eq('id', id);
    
    if (error) throw error;
  },

  async deleteServiceLocations(businessId: number): Promise<void> {
    const { error } = await supabase
      .from(TABLES.SERVICE_LOCATION)
      .delete()
      .eq('business_id', businessId);
    
    if (error) throw error;
  },

  async updateCountry(id: number, country: number): Promise<ServiceLocation> {
    return this.updateServiceLocation(id, { country });
  },

  async updateCity(id: number, city: number): Promise<ServiceLocation> {
    return this.updateServiceLocation(id, { city });
  },
}; 